import { SavedArticle } from 'components/main/saved-articles/interfaces'
import { CUSTOM_EVENT_TYPE } from 'constants/types'

export const onArticleClick = (article: SavedArticle) => {
    const detail = {
        event_name: 'click',
        control_fields: {
            mparticle: {
                keys: {
                    click_source_type: 'click_source_type',
                    article_id: 'article_id',
                    bookmarked: 'bookmarked'
                },
                mp_event_type: 'Navigation'
            }
        },
        click_source_type: 'link',
        article_id: article._id,
        bookmarked: 'true'
    }
    const event = new CustomEvent(CUSTOM_EVENT_TYPE, { detail })
    document.dispatchEvent(event)
}

export const onArticleUnsubscribe = (article: SavedArticle) => {
    const detail = {
        control_fields: {
            mparticle: {
                keys: {
                    action_type: 'action_type',
                    article_id: 'article_id',
                    context: 'context'
                }
            }
        },
        event_name: 'on_page_action_click',
        action_type: 'unsaved',
        article_id: article._id,
        context: 'saved_for_later'
    }
    const event = new CustomEvent(CUSTOM_EVENT_TYPE, { detail })
    document.dispatchEvent(event)
}
